<template>
  <el-menu
    class="menu-left"
    :collapse="collapse"
    :default-active="activeIndex"
    router
    unique-opened
  >
    <!-- 一级菜单 -->
    <template v-for="item in items">
      <el-submenu
        v-if="item.child.length > 0"
        :index="item.menuUrl"
        :key="item.menuUrl"
      >
        <template slot="title"
          ><i :class="item.icon"></i><span>{{ item.menuName }}</span></template
        >
        <!-- 二级菜单 -->
        <template v-for="itemChild in item.child">
          <el-submenu
            v-if="itemChild.child.length > 0"
            :index="itemChild.menuUrl"
            :key="itemChild.menuUrl"
          >
            <template slot="title"
              ><i :class="itemChild.icon"></i
              ><span>{{ itemChild.menuName }}</span></template
            >
            <!-- 三级菜单 -->
            <el-menu-item
              v-for="itemChild_Child in itemChild.child"
              :index="itemChild_Child.menuUrl"
              :key="itemChild_Child.menuUrl"
            >
              <i :class="itemChild_Child.icon"></i
              ><span slot="title">{{
                itemChild_Child.menuName
              }}</span></el-menu-item
            >
          </el-submenu>
          <el-menu-item
            v-else
            :index="itemChild.menuUrl"
            :key="itemChild.menuUrl"
            ><i :class="itemChild.icon"></i
            ><span slot="title">{{ itemChild.menuName }}</span></el-menu-item
          >
        </template>
      </el-submenu>
      <el-menu-item v-else :index="item.menuUrl" :key="item.menuUrl"
        ><i :class="item.icon"></i
        ><span slot="title">{{ item.menuName }}</span></el-menu-item
      >
    </template>
  </el-menu>
</template>

<script>
export default {
  computed: {
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(value) {
        this.$store.commit("setActiveIndex", value);
      }
    }
  },
  data() {
    return {
      collapse: false,
      items: []
    };
  },
  methods: {
    getUserMenuInfo() {
      let _this = this;
      let userInfo = JSON.parse(_this.$cookie.get("userInfo"));
      let param = {
        url: "/api/menu/getUserMenuInfo",
        params: {
          username: userInfo.username
        }
      };
      _this.$store.dispatch("getUserMenuInfo", param).then(() => {
        _this.items = this.$store.state.login.menu;
      });
    }
  },
  created() {
    let _this = this;
    _this.getUserMenuInfo();
  }
};
</script>

<style lang="sass" scoped></style>
